// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataCacheToolToolType } from "../DataCacheToolEnums.js";
import { FillableDataCacheTool } from "./FillableDataCacheTool.js";

export let TriangleDataCacheTool = function ()
{
    FillableDataCacheTool.apply(this);
    this.ToolType = DataCacheToolToolType.Triangle;
    this.InitPoints(3);
};

TriangleDataCacheTool.prototype = Object.create(FillableDataCacheTool.prototype);

TriangleDataCacheTool.prototype.MinPointsCount = function () { return 3; };
TriangleDataCacheTool.prototype.MaxPointsCount = function () { return 3; };